 const asyncWrapper = async (fn, ...args) => {
    try {
        const data = await fn(...args)
        return [data, null]
    }
    catch (error) {
        return [ null, error ]
    }
}

export default asyncWrapper;